export const REWARD = "reward"
